import { http } from "services/http";

import type { Language, LanguageAddRequest, LanguageUpdateRequest } from "models/languages.model";

export const languagesApi = {
  addLanguage: (data: LanguageAddRequest) => http.quiet().post("/api/languages/add", { ...data }),
  updateLanguage: (data: LanguageUpdateRequest) =>
    http.quiet().post("/api/languages/update", { ...data }),
  getLanguages: () => http.quiet().get<Language[]>("/api/languages"),
};
